// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.evaluation-form {
  margin-bottom: 20px;
}

.section-subtitle {
  color: #666;
  margin-bottom: 20px;
  font-size: 0.95rem;
}

.form-section {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e0e0e0;
}

.form-section h3 {
  color: #333;
  margin-bottom: 20px;
  font-size: 1.1rem;
}

.form-section:last-child {
  border-bottom: none;
}

.toggle-btn {
  background: #f5f5f5;
  color: #333;
  border: 1px solid #ddd;
  width: 100%;
  text-align: left;
  padding: 12px;
  font-size: 0.95rem;
  margin-bottom: 15px;
  transition: background-color 0.2s;
}

.toggle-btn:hover {
  background-color: #efefef;
}

.form-group.inline {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

@media (max-width: 600px) {
  .form-group.inline {
    grid-template-columns: 1fr;
  }
}

textarea {
  resize: vertical;
  font-family: inherit;
}

small {
  display: block;
  color: #999;
  font-size: 0.85rem;
  margin-top: 5px;
}

.form-actions {
  margin-top: 30px;
  text-align: center;
}

.submit-btn {
  padding: 12px 40px;
  font-size: 1rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.submit-btn:hover {
  opacity: 0.9;
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.form-note {
  text-align: center;
  color: #999;
  font-size: 0.85rem;
  margin-top: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/components/EvaluationForm.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".evaluation-form {\n  margin-bottom: 20px;\n}\n\n.section-subtitle {\n  color: #666;\n  margin-bottom: 20px;\n  font-size: 0.95rem;\n}\n\n.form-section {\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.form-section h3 {\n  color: #333;\n  margin-bottom: 20px;\n  font-size: 1.1rem;\n}\n\n.form-section:last-child {\n  border-bottom: none;\n}\n\n.toggle-btn {\n  background: #f5f5f5;\n  color: #333;\n  border: 1px solid #ddd;\n  width: 100%;\n  text-align: left;\n  padding: 12px;\n  font-size: 0.95rem;\n  margin-bottom: 15px;\n  transition: background-color 0.2s;\n}\n\n.toggle-btn:hover {\n  background-color: #efefef;\n}\n\n.form-group.inline {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n@media (max-width: 600px) {\n  .form-group.inline {\n    grid-template-columns: 1fr;\n  }\n}\n\ntextarea {\n  resize: vertical;\n  font-family: inherit;\n}\n\nsmall {\n  display: block;\n  color: #999;\n  font-size: 0.85rem;\n  margin-top: 5px;\n}\n\n.form-actions {\n  margin-top: 30px;\n  text-align: center;\n}\n\n.submit-btn {\n  padding: 12px 40px;\n  font-size: 1rem;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n}\n\n.submit-btn:hover {\n  opacity: 0.9;\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n.form-note {\n  text-align: center;\n  color: #999;\n  font-size: 0.85rem;\n  margin-top: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
